export const defaultSection = [
    {
        title: '基础信息',
        fieldsMatch: [
            {
                reg: /^syncUpdate$/,
                options: { hidden: true }
            },
            {
                reg: /^categoryData$/
            },
            {
                reg: /^title$/
            },
            {
                reg: /^catProp$/
            },
            // {
            //     reg: /^qualification$/
            // },
            {
                reg: /^stuffStatus$/
            },
            {
                reg: /^globalStockNav$/,
                options: {
                    required: true,
                    rules: [
                        {
                            required: true,
                            message: '必填'
                        }
                    ]
                }
            },
            {
                reg: /^country$/,
                props: {
                    style: {
                        width: '180px'
                    }
                },
                options: {
                    className: 'styles.procurement'
                }
            },
            {
                reg: /^stockType$/,
                options: {
                    className: 'styles.procurement'
                }
            },
            // {
            //     reg: /^legalCustoms$/,
            //     options: {
            //         required: true,
            //         rules: [
            //             {
            //                 required: true,
            //                 message: '必填'
            //             }
            //         ]
            //     }
            // },
            {
                reg: /^globalStock$/
            },
            {
                reg: /^departurePlace$/,
                options: {
                    required: true,
                    rules: [
                        {
                            required: true,
                            message: '必填'
                        }
                    ]
                }
            },
            // {
            //     reg: /^customize$/
            // },
            // {
            //     reg: /^shopcat$/
            // }
        ]
    },
    {
        title: '食品安全',
        fieldsMatch: [
            { reg: /^taobaoFoodPrdLicense$/ },
            { reg: /^taobaoFoodDesignCode$/ },
            { reg: /^taobaoFoodAdditive$/ },
            { reg: /^taobaoFoodFactoryName$/ },
            { reg: /^taobaoFoodFactorySite$/ },
            { reg: /^taobaoFoodFactoryContact$/ },
            { reg: /^taobaoFoodMix$/ },
            { reg: /^taobaoFoodPeriod$/ },
            { reg: /^taobaoFoodPlanStorage$/ },
            { reg: /^taobaoFoodSupplier$/ },
            { reg: /^taobaoFoodProduceDate$/ },
            { reg: /^taobaoFoodStockDate$/ }
        ]
    },
    {
        title: '销售信息',
        fieldsMatch: [
            {
                reg: /^deliveryTimeType$/
            },
            {
                reg: /^tbDeliveryTime$/,
            },
            {
                reg: /^openSkuDeliveryTime$/,
            },
            {
                reg: /^saleProp$/
            },
            {
                reg: /^goodsSku$/
            },
            {
                reg: /^marketPrice$/
            },
            {
                reg: /^goodsSkuDetail$/
            },
            {
                reg: /^price$/,
                props: {
                    style: {
                        width: '180px'
                    }
                }
            },
            {
                reg: /^quantity$/,
                props: {
                    style: {
                        width: '180px'
                    }
                }
            },
            {
                reg: /^itemWeight$/,
                props: {
                    style: {
                        width: '180px'
                    }
                }
            },
            {
                reg: /^outerId$/,
                props: {
                    style: {
                        width: '80%'
                    }
                }
            },
            {
                reg: /^barcode$/,
                props: {
                    style: {
                        width: '80%'
                    }
                }
            }
        ]
    },
    {
        title: '支付信息',
        fieldsMatch: [
            {
                reg: /^subStock$/
            },
            {
                reg: /^warranty$/
            },
            {
                reg: /^invoice$/
            },
            {
                reg: /^sellPromise$/
            },
            {
                reg: /^qualityIdentify$/
            }
        ]
    },
    // {
    //     title: '物流信息',
    //     fieldsMatch: [
    //         {
    //             reg: /^shopShelvesFreights$/
    //         },
    //         // {
    //         //     reg: /^tbExtractWay$/
    //         // },
    //         {
    //             reg: /^deliverVolumn$/
    //         },
    //         {
    //             reg: /^deliverWeight$/
    //         }
    //     ]
    // },
    {
        title: '图文描述',
        fieldsMatch: [
            {
                reg: /^multiplePic$/
            },
            {
                reg: /^images$/
            },
            // {
            //     reg: /^imageVideoType$/
            // },
            // {
            //     reg: /^imageVideo$/
            // },
            // {
            //     reg: /^threeToFourImages$/
            // },
            {
                reg: /^verticalImage$/
            },
            {
                reg: /^desc$/
            },
            {
                reg: /^wirelessDesc$/
            },
            // {
            //     reg: /^startTime$/
            // },
            {
                reg: /^shelfTime$/,
                props: {
                    style: {
                        width: '250px'
                    }
                }
            }
        ]
    }
]